import React from 'react';
import "./OurSpecialists.css";
import zdjNatMac from "../../../images/home/img_natalia_mackowiak.jpg";
import zdjAleksSaw from '../../../images/home/img_aleksandra_sawicka.jpg';
import zdjMonKos from '../../../images/home/img_monika_kosowska.jpg';
import { Link } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";

const OurSpecialists = () => {
  return (
    <section id="doctors" className="doctors">
      <div className="container">
        <div className="section-title text-center mb-3">
          <h2>NASI SPECJALIŚCI</h2>
          <p className="form-text">
            Twoje zdrowie psychiczne w rękach profesjonalistów.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-6 mt-3">
            <div className="member d-flex align-items-start">
              <div className="pic">
               <Link to="/specjalisci">
                  <img
                    src={zdjNatMac}
                    className="img-fluid"
                    alt="Natalia Maćkowiak"
                  />
                </Link>
              </div>
              <div className="member-info">
              <h4>Natalia Maćkowiak</h4>
                <span>Psycholog</span>
                <p>
                Jestem magistrem psychologii, a swoje doświadczenie zawodowe zdobywałam, pracując z 
                dziećmi...{" "}
                </p>
                <div className="text-center">
                  <Link to={"/specjalisci"} className="more-btn">
                    <BsFillArrowRightCircleFill /> Więcej o mnie
                    <i className="bx bx-chevron-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
{/*           <div className="col-lg-6 mt-3"> */}
{/*             <div className="member d-flex align-items-start"> */}
{/*               <div className="pic"> */}
{/*                 <Link to="/specjalisci"> */}
{/*                   <img */}
{/*                     src={zdjAleksSaw} */}
{/*                     className="img-fluid" */}
{/*                     alt="Aleksandra Sawicka" */}
{/*                   /> */}
{/*                 </Link> */}
{/*               </div> */}
{/*               <div className="member-info"> */}
{/*               <h4>Aleksandra Sawicka</h4> */}
{/*                 <span>Psycholog</span> */}
{/*                 <p> */}
{/*                   Jestem psychologiem pasjonującym się neuroróżnorodnością...{" "} */}
{/*                 </p> */}
{/*                 <div className="text-center"> */}
{/*                   <Link to={"/specjalisci"} className="more-btn"> */}
{/*                     <BsFillArrowRightCircleFill /> Więcej o mnie */}
{/*                     <i className="bx bx-chevron-right"></i> */}
{/*                   </Link> */}
{/*                 </div> */}
{/*               </div> */}
{/*             </div> */}
{/*           </div> */}
{/*           <div className="col-lg-6 mt-3"> */}
{/*             <div className="member d-flex align-items-start"> */}
{/*               <div className="pic"> */}
{/*                 <Link to="/specjalisci"> */}
{/*                   <img */}
{/*                     src={zdjMonKos} */}
{/*                     className="img-fluid" */}
{/*                     alt="Monika Kosowska" */}
{/*                   /> */}
{/*                 </Link> */}
{/*               </div> */}
{/*               <div className="member-info"> */}
{/*               <h4>Monika Kosowska</h4> */}
{/*                 <span>Psycholog</span> */}
{/*                 <p> */}
{/*                   Jestem psychologiem z doświadczeniem w pracy terapeutycznej z osobami dorosłymi oraz dziećmi...{" "} */}
{/*                 </p> */}
{/*                 <div className="text-center"> */}
{/*                   <Link to={"/specjalisci"} className="more-btn"> */}
{/*                     <BsFillArrowRightCircleFill /> Więcej o mnie */}
{/*                     <i className="bx bx-chevron-right"></i> */}
{/*                   </Link> */}
{/*                 </div> */}
{/*               </div> */}
{/*             </div> */}
{/*           </div> */}
        </div>
      </div>
    </section>
  );
};

export default OurSpecialists;
